import { IStoreCarWashOption } from '@ocx-app/modules/stores/types';

import { PaymentItem } from '@ocx/data-payment-provider';
import { CarWashInput } from '@ocx/graphql';

export const buildCarWashInput = (option: IStoreCarWashOption | null): CarWashInput | null => {
  let carWashInput: CarWashInput | null = null;

  if (option && option.productCode && option.posCodeModifier && option.posCode) {
    carWashInput = {
      productCode: option.productCode,
      posCode: option.posCode,
      posCodeModifier: option.posCodeModifier,
      amount: 1, // TODO find out the purpose of the field
    };
  }
  return carWashInput;
};

type GeneratePaymentItemsParams = {
  selectedCarWashOption?: IStoreCarWashOption | null;
};

export const buildPaymentItems = (params: GeneratePaymentItemsParams): PaymentItem[] => {
  const { selectedCarWashOption = null } = params;

  const items: PaymentItem[] = [
    {
      label: 'FUEL (TBD)',
      price: '1',
      status: 'PENDING',
    },
  ];
  if (selectedCarWashOption !== null) {
    items.push({
      label: `Car wash: ${selectedCarWashOption.name}`,
      price: selectedCarWashOption.unitPrice.toString(),
      status: 'FINAL',
    });
  }
  return items;
};
